import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=273219ca&scoped=true"
import script from "./DocumentView.vue?vue&type=script&lang=js"
export * from "./DocumentView.vue?vue&type=script&lang=js"
import style0 from "./DocumentView.vue?vue&type=style&index=0&id=273219ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273219ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273219ca')) {
      api.createRecord('273219ca', component.options)
    } else {
      api.reload('273219ca', component.options)
    }
    module.hot.accept("./DocumentView.vue?vue&type=template&id=273219ca&scoped=true", function () {
      api.rerender('273219ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/reinbursement/components/details/DocumentView.vue"
export default component.exports